<template>
  <div id="app" :style="getAppFont()">
    <section id="top-section">
      <Navbar />

      <div id="my-name">
        <span id="my-name__name">{{ $t("I'm Sarkhel Saeed") }}</span>
        <span :id="isRtl ? 'my-name__description__rtl' : 'my-name__description'">{{
          $t('Founder and CEO of Mirka Group')
        }}</span>
      </div>
    </section>

    <section id="my-achievement">
      <MyAchievement />
    </section>

    <section id="about-me">
      <AboutMe />
    </section>

    <section id="contact-me">
      <ContactMe />
    </section>

    <a @click="backToTop()" id="scroll-to-top">
      <span id="top-icon">&#x029A7;</span>
    </a>
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import MyAchievement from './components/MyAchievement.vue'
import AboutMe from './components/AboutMe.vue'
import ContactMe from './components/ContactMe.vue'
import { mapGetters } from 'vuex'

export default {
  mounted() {
    this.$i18n.locale = this.locale
    const app = document.querySelector('#app')
    if (this.isRtl) {
      app.style.direction = 'rtl'
    } else {
      app.style.direction = 'ltr'
    }

    window.addEventListener('scroll', () => {
      const scrlBtn = document.getElementById('scroll-to-top')
      if (
        document.body.scrollTop > 120 ||
        document.documentElement.scrollTop > 120
      ) {
        scrlBtn.style.display = 'flex'
      } else {
        scrlBtn.style.display = 'none'
      }
    })
  },

  computed: {
    ...mapGetters({
      locale: 'getLocale',
      isRtl: 'getRtl'
    })
  },

  components: {
    Navbar,
    AboutMe,
    MyAchievement,
    ContactMe
  },

  methods: {
    getAppFont() {
      if (this.$i18n.locale === 'en') return { fontFamily: 'Raleway' }
      return { fontFamily: 'Rudaw' }
    },

    backToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style lang="scss">
@font-face {
  font-family: 'Rudaw' !important;
  src: url('./fonts/rudaw_font.ttf') format('truetype');
}

@font-face {
  font-family: 'Raleway' !important;
  src: url('./fonts/Raleway-Medium.ttf');
}
$secondaryColor: #e01e37;
$primaryColor: #38285a;
$backgroundColor: #e1e5e8;

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $primaryColor;
}

#top-section {
  position: relative;
  width: 100%;
  background-image: url('./assets/profile_picture.jpg');
  background-size: cover;
  background-position: center;
}

#my-name {
  position: absolute;
  top: 50%;
  left: 5%;
  transform: translateY(-50%);
  font-size: 38px;
  color: $primaryColor;
}
#my-name__name {
  display: flex;
  float: left;
}
#my-name__description {
  display: flex;
  float: left;
}
#my-name__description__rtl {
  display: flex;
  float: left;
}
#scroll-to-top {
  position: fixed;
  z-index: 1000;
  bottom: 20px;
  right: 20px;
  cursor: pointer;
  border-radius: 4px;
  width: 50px;
  height: 50px;
  background-color: $secondaryColor;
  display: none;
  justify-content: center;
  align-items: center;
  box-shadow: 3px 3px 12px rgba(0, 0, 0, 0.5);
}

#top-icon {
  color: #fff;
  padding-bottom: 5px;
  font-size: 40px;
  transform: rotate(23deg);
}

.social-row {
  margin-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

// Mobile
@media (max-width: 767px) {
  #top-section {
    height: 40vh;
  }
  #my-name {
    font-size: 22px;
  }
  #my-name__name {
    width: 55%;
    padding-bottom: 5px;
  }
  #my-name__description {
    width: 60%;
  }
  #my-name__description__rtl {
    width: 55%;
  }
  .social-col {
    width: 18%;
    text-align: center;
  }
  .top-links-desktop {
    display: none;
  }
  .menu-btn,
  .rtl-menu-btn {
    display: flex;
  }
  #my-achievement {
    padding: 100px 20px;
  }
  .card-row {
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  .col {
    width: 100%;
  }
  #about-me {
    padding: 100px 0px;
  }
  #about-text {
    width: 85%;
    margin: auto;
    line-height: 1.6;
  }
  #about-text > li {
    margin-bottom: 7px;
  }
  #contact-me {
    padding: 100px 0px;
  }
}

// iPad
@media (min-width: 768px) {
  .top-links-desktop {
    display: none;
  }
  .menu-btn,
  .rtl-menu-btn {
    display: flex;
  }
  #top-section {
    height: 53vh;
  }
  #my-name {
    font-size: 30px;
  }
  #my-name__name {
    width: 70%;
    padding-bottom: 10px;
  }
  #my-name__description {
    width: 60%;
  }
  #my-name__description__rtl {
    width: 70%;
  }
  .social-col {
    width: 12%;
    text-align: center;
  }
  #nav-ul > li {
    color: $secondaryColor;
    display: inline;
    padding: 10px 8px;
    // font-weight: bold;
  }
  .social-ul {
    padding-left: 20px;
    list-style: none;
    display: inline-block;
  }
  #my-achievement {
    padding: 100px 30px;
  }
  .card-row {
    width: 100%;
  }
  .col {
    width: 40%;
  }
  #about-text {
    width: 85%;
    margin: auto;
    line-height: 1.6;
  }
  #about-text > li {
    margin-bottom: 7px;
  }
}

// iPad Pro
@media (min-width: 992px) {
  .top-links-desktop {
    display: block;
  }
  .menu-btn,
  .rtl-menu-btn {
    display: none;
  }
  #my-name {
    font-size: 36px;
  }
  #my-name__name {
    width: 80%;
    padding-bottom: 10px;
  }
  #my-name__description {
    width: 50%;
  }
  #my-name__description__rtl {
    width: 80%;
  }
  #top-section {
    height: 53vh;
  }
  #nav-ul > li {
    color: $secondaryColor;
    display: inline;
    padding: 10px 15px;
  }
  .social-ul {
    padding-left: 40px;
    list-style: none;
    display: inline-block;
  }
  .social-col {
    width: 15%;
    text-align: center;
  }
  #my-achievement {
    padding: 100px 50px;
  }
  .card-row {
    width: 90%;
  }
  .col {
    width: 40%;
  }
  #about-text {
    width: 70%;
    margin: auto;
    line-height: 1.6;
  }
  #about-text > li {
    margin-bottom: 7px;
  }
}

// LG
@media (min-width: 1200px) {
  #top-section {
    height: 100vh;
  }
  #my-name__name {
    width: 80%;
    padding-bottom: 10px;
  }
  #my-name__description {
    width: 80%;
  }
  #my-name__description__rtl {
    width: 80%;
  }
  .social-col {
    width: 12%;
    text-align: center;
  }
  #my-achievement {
    padding: 100px 70px;
  }
  .card-row {
    width: 75%;
  }
  .col {
    width: 40%;
  }
  #about-text {
    width: 50%;
    margin: auto;
    line-height: 1.6;
  }
  #about-text > li {
    margin-bottom: 7px;
  }
}

// XL
@media (min-width: 1920px) {
  .social-col {
    width: 6%;
    text-align: center;
  }
  #top-section {
    height: 100vh;
  }
  #my-achievement {
    padding: 100px 70px;
  }
  .card-row {
    width: 100%;
  }
  .col {
    width: 20%;
  }
  #about-text {
    width: 35%;
    margin: auto;
    line-height: 1.6;
  }
  #about-text > li {
    margin-bottom: 7px;
  }
}
</style>
